import visualTagPickerView from './visualTagPickerComponent.html';
import './visualTagPickerComponent.css';
import _ from 'lodash';
import { ensure } from 'components/sharpr/ensure/ensure';

export function visualTagPickerComponent() {
	return {
		bindings: {
			tags: '<',
			model: '=',
		},
		controllerAs: 'vm',
		controller: visualTagPickerComponentCtrl,
		template: visualTagPickerView,
	};
}

export class visualTagPickerComponentCtrl {
	constructor($timeout, $element, $scope) {
		'ngInject';
		// save injections
		this.$timeout = $timeout;
		this.$element = $element;
		// bind callbacks to ourself
		this.matchesFilter = this.matchesFilter.bind(this);
		this.regroup = this.regroup.bind(this);
		this.setupTags = this.setupTags.bind(this);
		this.preloadImages = this.preloadImages.bind(this);
		// update ui when user types in filter
		$scope.$watch('vm.filterText', this.regroup);
		$scope.$watch('vm.tags', this.setupTags);
		$scope.$watch('vm.tags', this.preloadImages);
		$scope.$watchCollection('vm.model', this.setupTags);
	}

	$onInit() {
		// setup groups and layout
		this.groupings = this.getGroupings();
		this.grouping = 'Alphabetical';
		this.layouts = this.getLayouts();
		this.layout = 'icons';
		this.setupTags();
		this.preloadImages();
	}

	preloadImages() {
		this.tags.forEach(tag => (new Image().src = tag.large_image));
		this.tags.forEach(tag => (new Image().src = tag.small_image));
	}

	setupTags() {
		// select tags that appear in model
		const chosenNames = ensure.array(this.model).map(tag => tag.name);
		ensure.array(this.tags).forEach(vtag => {
			vtag.searchText = (
				vtag.name +
				' ' +
				vtag.label +
				' ' +
				vtag.category +
				' ' +
				vtag.description_1 +
				' ' +
				vtag.description_2 +
				' '
			).toLocaleLowerCase();
			vtag.selected = chosenNames.indexOf(vtag.tag_name) > -1;
		});
	}

	getGroupings() {
		return [
			{ value: 'Alphabetical', label: 'Alphabetically' },
			{ value: 'Type', label: 'By Macro/Mega' },
			{ value: 'Category', label: 'By Category' },
			{ value: 'Random', label: 'Randomly' },
		];
	}

	getLayouts() {
		return [
			{ value: 'tiled', label: 'Tiles' },
			{ value: 'icons', label: 'Text and Icons' },
			{ value: 'text', label: 'Text Only' },
		];
	}

	regroup() {
		this.groups = this['groupBy' + this.grouping]();
	}

	updateModel(tag) {
		if (tag.selected) {
			this.model.push({
				id: tag.tag_id,
				name: tag.tag_name,
				$search: tag.tag_name,
				label: tag.label,
				small_image: tag.small_image,
				large_image: tag.large_image,
			});
		} else {
			const idx = _.findIndex(this.model, { name: tag.tag_name });
			if (idx > -1) {
				this.model.splice(idx, 1);
			}
		}
	}

	toggleSelection(tag) {
		tag.selected = !tag.selected;
		this.updateModel(tag);
	}

	isBotTile(idx) {
		return [1, 3].indexOf(idx % 5) > -1;
	}

	groupByAlphabetical() {
		return this._groupByFunction(tag => tag.label.slice(0, 1).toUpperCase());
	}

	groupByType() {
		return this._groupByFunction(tag => tag.type);
	}

	groupByCategory() {
		return this._groupByFunction(tag => tag.category);
	}

	groupByRandom() {
		return [
			{
				label: false,
				tags: _.shuffle(this.tags.filter(this.matchesFilter)),
			},
		];
	}

	matchesFilter(tag) {
		if (!this.filterText) {
			return true;
		}
		return tag.searchText.indexOf(this.filterText.toLocaleLowerCase()) > -1;
	}

	showTooltip($event, tag, idx) {
		const componentRect = this.$element[0].getBoundingClientRect();
		const tagRect = $event.$element[0].getBoundingClientRect();
		// console.log('componentRect', componentRect);
		// console.log('tagRect', tagRect);
		let offsetX, offsetY, neckPosition;
		if (this.layout == 'tiled') {
			const xOffsetByPos = [138, 138, -258, -336, -336];
			const neckByPos = ['left', 'left', 'right', 'right', 'right'];
			offsetX = xOffsetByPos[idx % 5];
			offsetY = -139;
			neckPosition = neckByPos[idx % 5];
		} else {
			// layout of icons or text
			offsetX = idx % 2 ? -20 : 0;
			offsetY = tagRect.top > 340 ? -192 : -5;
			neckPosition = tagRect.top > 340 ? 'bottom' : 'top';
		}
		this.tooltipLeft = tagRect.left - componentRect.left + offsetX;
		this.tooltipTop = tagRect.top - componentRect.top + tagRect.height + offsetY;
		this.tooltipTag = tag;
		this.tooltipNeck = 'neck-' + neckPosition;

		// this.debugSquare = document.createElement('div');
		// this.debugSquare.style.border = '2px solid blue';
		// this.debugSquare.style.position = 'absolute';
		// this.debugSquare.style.top = tagRect.top + 'px';
		// this.debugSquare.style.left = tagRect.left + 'px';
		// this.debugSquare.style.width = tagRect.width + 'px';
		// this.debugSquare.style.height = tagRect.height + 'px';
		// this.debugSquare.style.zIndex = '100';
		// document.body.appendChild(this.debugSquare);
	}

	hideTooltip() {
		this.tooltipTag = null;

		// this.debugSquare && document.body.removeChild(this.debugSquare);
		// this.debugSquare = null;
	}

	_groupByFunction(fn) {
		// gather tags by each group's label
		const byLabel = {};
		this.tags.forEach(tag => {
			// check that tag matches the search text
			if (!this.matchesFilter(tag)) {
				return;
			}
			// depending on fn, label could be a letter of the alphabet,
			// the category name, or macro/mega
			const label = fn(tag);
			// if there are not yet any groups with this name, start one
			if (!byLabel[label]) {
				byLabel[label] = [];
			}
			// add this tag to this group
			byLabel[label].push(tag);
		});
		// then turn into an array where each group has label and tags
		const groups = [];
		_.forOwn(byLabel, (tags, label) => {
			groups.push({ label, tags });
		});
		// and finally, sort by label
		return _.sortBy(groups, 'label');
	}
}
